import type { SVGProps } from 'react';

import { Icon } from './Icon';

const CodeIcon = (props: SVGProps<SVGSVGElement>) => (
  <Icon viewBox="0 0 16 10" {...props}>
    <path
      d="M4.71146 9.42292L0 4.71146L4.71146 0L5.4775 0.766042L1.54 4.70354L5.48542 8.64896L4.71146 9.42292ZM10.7115 9.42292L9.94542 8.65688L13.8829 4.71938L9.9375 0.773959L10.7115 0L15.4229 4.71146L10.7115 9.42292Z"
      fill="#3C3C3E"
    />
  </Icon>
);

export default CodeIcon;
